var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"agent-avatar"}},[_c('div',{staticClass:"agent-avatar-image"},[_c('v-img',{attrs:{"src":_vm.img,"alt":"John"}})],1),_c('div',{staticClass:"agent-avatar-state-icon"},[_c('Icon',{attrs:{"size":21,"color":'green',"icon":"circle-filled"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }